<template>
  <div class="session_wrapp_info">
    <h3>
      {{ sessionElement.node.name }} {{ sessionElement.node.date }}
      {{ sessionElement.node.time }}
    </h3>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="session_btn"
          v-bind="attrs"
          v-on="on"
          x-small
          @click="editSession()"
          >Edit Session</v-btn
        >
      </template>
      <span>Edit Session</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="session_btn"
          v-bind="attrs"
          v-on="on"
          x-small
          @click="removeSession(sessionElement.node.seqno)"
          >Remove Session</v-btn
        >
      </template>
      <span>Remove Session</span>
    </v-tooltip>
    <v-dialog v-model="dialogSession" :retain-focus="false" max-width="700px">
      <MeetSessionForm
        :meetId="sessionElement.node.meetId.toString()"
        :seqno="sessionElement.node.seqno"
        @close-form="closeSessionEvent"
        @set-loading="loading = $event"
      ></MeetSessionForm>
    </v-dialog>
    <template>
      <div class="wrap_session">
        <drop-list
          :items="eventItems"
          class="main"
          @insert="onInsert"
          @reorder="$event.apply(eventItems)"
        >
          <template v-slot:item="{ item }">
            <drag class="item" :key="item.node.eventId"
              >{{ item.node.event.distance }} {{ item.node.event.stroke }}
              <v-btn x-small @click="removeEvent(item.node.seqno)"
                >Remove Event</v-btn
              >
            </drag>
          </template>
          <template v-slot:feedback="{ data }">
            <div class="item feedback" :key="data.node.eventId">
              {{ data.node.distance }} {{ data.node.stroke }}
            </div>
          </template>
        </drop-list>
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import MeetSessionForm from "../../forms/meetSessionForm.vue";
import { Drag, DropList } from "vue-easy-dnd";

export default {
  components: {
    MeetSessionForm,
    Drag,
    DropList
  },
  props: {
    sessionElement: {}
  },
  data() {
    return {
      dialogSessionEvent: false,
      dialogSession: false,
      loading: true,
      formValid: true,
      meetSessionEvents: [],
      dropped: [],
      meetData: {
        sessionSeqno: +this.sessionId,
        eventId: 0,
        externalEventId: 0,
        updateSource: "PDI Loader"
      }
    };
  },
  computed: {
    ...mapGetters(["allSessionEvent"]),
    eventItems() {
      console.log(this.allSessionEvent);
      let result = this.allSessionEvent.edges.filter(item => {
        return item.node.sessionSeqno == this.sessionElement.node.seqno;
      });
      for (let i = 0; i < result.length; i++) {
        if (result[i].node.position == null) {
          result[i].node.position = i + 1;
        }
      }
      return result;
    }
  },
  methods: {
    ...mapActions([
      "deleteCurrentSessionEvent",
      "deleteCurrentSession",
      "addNewSessionEvent"
    ]),
    closeSessionEvent() {
      this.dialogSession = false;
    },
    closeSession() {
      this.dialogSession = false;
    },
    dragEnd(event) {
      console.log(event, "dragEnd");
    },
    onInsert(event) {
      console.log(this.eventItems, "eventItems");
      let position =
        this.eventItems[this.eventItems.length - 1].node.position + 1;
      let dataToAdd = {
        __typename: "MeetEventConnectionsEdge",
        node: {
          event: event.data.node,
          eventId: event.data.node.eventId,
          externalEventId: 0,
          meetId: this.sessionElement.node.meetId,
          sessionSeqno: 0,
          seqno: 0,
          updateSource: "PDI Loader",
          position: position
        }
      };
      this.eventItems.splice(event.index, 0, dataToAdd);
      this.meetData.eventId = +event.data.node.eventId;
      this.meetData.externalEventId = 0;
      this.meetData.sessionSeqno = +this.sessionElement.node.seqno;
      this.meetData.updateSource = "PDI Loader";
      this.meetData.event = event;
      this.meetData.position = dataToAdd.node.position;
      this.addSessionEvent();
    },
    eventsFiltred(elem) {
      return this.allSessionEvent.edges
        .filter(item => {
          return item.node.sessionSeqno == elem.node.seqno;
        })
        .map(item => {
          return item.node.eventId;
        });
    },
    addSessionEvent() {
      this.$emit("set-loading", true);
      if (this.formValid) {
        this.addNewSessionEvent({
          ...this.meetData
        })
          .then(() => {
            console.log(this.meetData);
            this.$toast.success(
              `${this.meetData.event.data.node.distance +
                " " +
                this.meetData.event.data.node.stroke} has been added`
            );
            this.$emit("set-loading", false);
            this.closeSessionEvent();
          })
          .catch(error => {
            console.error(error);
            this.$emit("set-loading", false);
            this.closeSessionEvent();
          });
      } else {
        this.$emit("set-loading", false);
        // this.validateForm();
      }
    },
    editSession() {
      this.dialogSession = true;
    },
    removeEvent(seqno) {
      let result = confirm("Are you sure to delete event");
      if (result) {
        this.deleteCurrentSessionEvent({
          seqno: parseInt(seqno, 10)
        })
          .then(() => {
            this.$toast.error("Event has been deleted");
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    removeSession(seqno) {
      let result = confirm("Are you sure to delete session");
      if (result) {
        this.deleteCurrentSession({
          seqno: parseInt(seqno, 10)
        })
          .then(() => {
            this.$toast.error("Session has been deleted");
          })
          .catch(error => {
            console.error(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.wrap_session {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.main {
  width: 100%;
  min-height: 100px;
}
.session_btn {
  margin: 10px 10px 10px 0;
}
</style>
